import React from 'react';
import Spinner from 'react-bootstrap/Spinner';


const LoadingDailog = ({ isLoading = false }) => {
 
  return (
    <>
       <div style={{ display: isLoading ? 'flex' : 'none' }} className="modalLoading">
        <button type="button" className="btn btn-primary disabled btn-lg ">
          <span>
            <Spinner animation="grow" variant="light"/>
            <Spinner animation="grow" variant="light"/>
            <Spinner animation="grow" variant="light"/>
          </span>
        </button>
      </div>

    </>
  );
};

export default LoadingDailog;

export const ContinuousLoading = () => {
  return <div className="customContinuousLoading"></div>;
};
